import { Controller } from "@hotwired/stimulus";
import { visit } from "@hotwired/turbo";

export default class extends Controller<HTMLElement> {
  static targets = ["back", "forward"];

  declare readonly backTarget: HTMLAnchorElement;
  declare readonly forwardTarget: HTMLAnchorElement;

  private _onKeydown = this._keyHandler.bind(this);

  connect() {
    window.addEventListener("keydown", this._onKeydown);
  }

  disconnect() {
    window.removeEventListener("keydown", this._onKeydown);
  }

  private _keyHandler(event: KeyboardEvent) {
    if ((event.metaKey || event.ctrlKey) && event.key === "ArrowUp") {
      event.preventDefault(); // optional: stops default browser behavior

      if (this.backTarget.href) {
        visit(this.backTarget.href);
      }
    }
    if ((event.metaKey || event.ctrlKey) && event.key === "ArrowDown") {
      event.preventDefault(); // optional: stops default browser behavior

      if (this.forwardTarget.href) {
        visit(this.forwardTarget.href);
      }
    }
  }
}
